import React from 'react'
import s from './Leaderboard.module.scss'
import cx from 'classnames'

import LeaderBoardImg from 'assets/images/new-ui/menu-leaderboard.png'

import ScoreListNational from 'components/ScoreListNational'

import {useParams} from "react-router-dom";
import useQuery from "hooks/useQuery";

Leaderboard.defaultProps = {

};

export default function Leaderboard({ className }) {
  const lang = useQuery().get("lang") || "en";
  const translate = {
    leaderboardImage : {
      en: {
        img: require("assets/images/en/leaderboard/menu-leaderboard.png").default,
        alt: "Gift Ideas. National Leaderboard"
      },
      es: {
        img: require("assets/images/es/leaderboard/menu-leaderboard.png").default,
        alt: "Ideas de regalos. Tablero nacional de posiciones"
      },
    },
  }

  return (
    <div className={cx(s.Leaderboard, className)}>
      <img className={s.board} src={translate.leaderboardImage[lang].img} alt={translate.leaderboardImage[lang].alt} />
      <div className={s.content}>
        <ScoreListNational className={s.ScoreList}/>
      </div>
    </div>
  );
}
